import { type BillingEntityTypeEnum } from '@api/READ_ONLY/billing_api/Api';

export type BalanceTabKey = BillingEntityTypeEnum;
export const DEFAULT_BALANCES_SORT = '-transaction';

export type BalanceRow = {
  id: number;
  key: string;
  entityId: number;
  entityType: BillingEntityTypeEnum;
  name: string;
  transaction: string;
  balance: number;
  createdAt?: string | null;
};
